import styled from "styled-components";

export const StyledDiv=styled.div`
  background-color  : #eff9fe;
  border-top: 3px solid #d2ecfc;
  border-bottom:3px solid #d2ecfc;
  padding: 30px;
  word-spacing: 0px;
`